import styled from 'styled-components'
import { Button, Checkbox } from '@dsny/dsny-component-library'

export const Title = styled.h5`
  font-family: Nunito Sans;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 32px;
  text-align: left;
  color: ${({ theme }) => theme.colors.neutralW100};
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  padding: 48px 24px;
`

export const FormWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 24px;
  max-width: 468px;
`

export const FullWidthButton = styled(Button)`
  width: 100%;
  height: 36px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FooterText = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  margin-top: 24px;
  justify-content: center;
  color: ${({ theme }) => theme.colors.neutralW100};
`

export const ForgotPasswordLabel = styled.span`
  display: inline-flex;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.player50};
  cursor: pointer;
`

export const StyledCheckbox = styled(Checkbox)`
  margin-right: 6px;

  div {
    width: 16px;
    height: 16px;
    border: ${({ checked, theme }) =>
      checked ? 'unset' : ` 1px solid ${theme.colors.neutralW90}}`};
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const CheckboxLabel = styled.label`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutralW100};
`

export const PasswordWrapper = styled.div`
  svg {
    fill: ${({ theme }) => theme.colors.neutralW70};
  }
`

export const HelpText = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 16.37px;
  text-align: left;
  color: ${({ theme }) => theme.colors.interact70};
  margin-left: 10px;
`

export const SignUpLink = styled.span`
  font-size: 14px;
  font-weight: 700;
  padding-left: 0.25rem;
  color: ${({ theme }) => theme.colors.player50};
  cursor: pointer;
`
